import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { timer } from 'rxjs';

@Component({
  selector: 'app-datetoday',
  templateUrl: './datetoday.component.html',
  styleUrls: ['./datetoday.component.scss']
})
export class DateTodayComponent implements OnInit {

  dateTimeToday : any = '';
  constructor(private datePipe : DatePipe) { 
    timer(0,1000).subscribe(()=>{
      this.dateTimeToday=datePipe.transform(Date.now(),'hh:mm , MMMM dd yyyy');
    })
  }

  ngOnInit(): void {
  }

}
